<template>
  <v-dialog :value="opened" width="600" persistent>
    <v-card class="content-container">
      <v-card-text>
        <v-flex column xs12>
          <v-layout class="mb-3 text-xs-left" column>
            <div class="mt-2">
              <p style="font-size: 16px">
                Do you want to convert all images to pdfs and download? This
                process might takes a few minutes. You will receive a
                notification when the zip file is ready for download.
              </p>
            </div>
          </v-layout>

          <v-layout>
            <v-spacer class="hidden-xs-only" />
            <v-btn
              class="default-input text-none primary primary--text"
              outline
              @click="downloadMultiple(false)"
            >
              No. Don't convert images to PDFs.
            </v-btn>

            <v-btn
              class="default-input text-none primary"
              @click="downloadMultiple(true)"
            >
              Yes. Convert images to PDFs.
            </v-btn>
          </v-layout>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';
import { mapGetters } from 'vuex';

export default {
  name: 'DownloadFolderDialog',

  props: {
    opened: {
      type: Boolean,
    },

    documents: {
      type: Array,
    },

    currentCompanyId: {
      type: Number,
    },
  },

  data() {
    return {};
  },

  methods: {
    async downloadMultiple(convertImageToPdf) {
      try {
        this.$emit('update:opened', false);

        await API.integration.downloadMultipleDocuments({
          companyId: this.currentCompanyId,
          documents: this.documents,
          convertImageToPdf,
        });
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'There was a problem downloading the folder.',
        });
      }
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
    }),
  },
};
</script>

<style lang="postcss" scoped>
.dialog-title {
  padding: 10px 0px;

  & >>> h4 {
  }
}
</style>
